import { render, staticRenderFns } from "./CDialogSurvey.vue?vue&type=template&id=84b9d012&scoped=true"
import script from "./CDialogSurvey.vue?vue&type=script&setup=true&lang=js"
export * from "./CDialogSurvey.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CDialogSurvey.vue?vue&type=style&index=0&id=84b9d012&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b9d012",
  null
  
)

export default component.exports